import {
  ADD_CAMPAIGN_MEDIA_BUYERS,
  DELETE_CAMPAIGN_MEDIA_BUYERS,
  GET_CAMPAIGN_MEDIA_BUYER_PROFILE,
  GET_CAMPAIGN_MEDIA_BUYERS_LIST,
  HIDE_CAMPAIGN_MEDIA_BUYERS_LOADER,
  SET_CAMPAIGN_MEDIA_BUYER_PROFILE,
  SET_CAMPAIGN_MEDIA_BUYER_USERS_INFO,
  SET_CAMPAIGN_MEDIA_BUYERS_LIST,
  SET_ERROR_CAMPAIGN_MEDIA_BUYER_PROFILE,
  SHOW_CAMPAIGN_MEDIA_BUYERS_LOADER,
  UPDATE_CAMPAIGN_MEDIA_BUYER_PROFILE
} from "./actionTypes";

export const getCampaignMediaBuyersList = data => ({
  type: GET_CAMPAIGN_MEDIA_BUYERS_LIST,
  payload: data
})

export const setCampaignMediaBuyersList = payload => ({
  type: SET_CAMPAIGN_MEDIA_BUYERS_LIST,
  payload
})

export const setCampaignMediaBuyerUsersInfo = payload => ({
  type: SET_CAMPAIGN_MEDIA_BUYER_USERS_INFO,
  payload
})

export const showCampaignMediaBuyersListLoader = () => ({
  type: SHOW_CAMPAIGN_MEDIA_BUYERS_LOADER
})

export const hideCampaignMediaBuyersListLoader = () => ({
  type: HIDE_CAMPAIGN_MEDIA_BUYERS_LOADER
})

export const addCampaignMediaBuyer = (mediaBuyer = {}, data = {}) => ({
  type: ADD_CAMPAIGN_MEDIA_BUYERS,
  payload: { mediaBuyer, data }
});

export const deleteCampaignMediaBuyer = (id, data = {}) => ({
  type: DELETE_CAMPAIGN_MEDIA_BUYERS,
  payload: { id, data }
});

export const getCampaignMediaBuyerProfile = id => ({
  type: GET_CAMPAIGN_MEDIA_BUYER_PROFILE,
  payload: id
});

export const setCampaignMediaBuyerProfile = payload => ({
  type: SET_CAMPAIGN_MEDIA_BUYER_PROFILE,
  payload
});

export const updateCampaignMediaBuyerProfile = (id, mediaBuyer = {}, data = {}) => ({
  type: UPDATE_CAMPAIGN_MEDIA_BUYER_PROFILE,
  payload: {id, mediaBuyer, data }
});

export const setErrorCampaignMediaBuyerProfile = payload => ({
  type: SET_ERROR_CAMPAIGN_MEDIA_BUYER_PROFILE,
  payload
});